const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Formats the date components supplied by the API without constructing a
// browser Date object, so no client timezone conversion can occur.
export function formatBackendDate(value) {
  if (!value) return "N/A";
  const rawValue = String(value).trim();
  const match = rawValue.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/,
  );
  if (!match) return rawValue;
  const [, year, month, day, hour = "00", minute = "00"] = match;
  const monthLabel = MONTHS[Math.max(0, Number(month) - 1)] || month;
  return `${monthLabel} ${day}, ${year}, ${hour}:${minute}`;
}
